import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import classNames from "classnames"

import { usePostVendorAlertUnfreezeMutation } from "store/api/adminApi"
import { usePostAlertUnfreezeMutation } from "store/api/alertsApi"
import { ApiTypes } from "types"
import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconUnfreeze } from "assets/svg/modal-icon-unfreeze.svg"

import getErrorMessage from "utils/getErrorMessage"
import { ModalLayout } from "layouts/ModalLayout"

interface Props {
  isVendor?: boolean
  onCancel: () => void
  onSuccess: () => void
  currentAlerts: ApiTypes.Model.Alert[]
}

export const AlertsUnfreezeModal = ({ isVendor, onCancel, onSuccess, currentAlerts }: Props) => {
  const [triggerAlertUnfreeze, { isLoading }] = isVendor
    ? usePostVendorAlertUnfreezeMutation()
    : usePostAlertUnfreezeMutation()

  const onSubmit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()

    try {
      const res = await triggerAlertUnfreeze(currentAlerts.map(alert => alert.id))
      const error = getErrorMessage(res?.error)

      if (res?.error) {
        toast.error(error)
      } else {
        toast.success("Alert has been successfully unfrozen!")
        onSuccess()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout width="450px" isFetching={isLoading} onConfirm={onSubmit} onCancel={onCancel}>
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconUnfreeze />
            <h3 className={styles.modalTitle}>Unfreeze</h3>
            <div className={styles.modalMessage}>
              By unfreezing you will start receiving alert(s) on the selected thermostat(s). Are you sure you want to
              unfreeze the alert(s)?
            </div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
